import { ArrowUpRight, Star } from "lucide-react";
import { REVIEWS, SALON } from "@/data/salon";
import { Overline, Reveal } from "@/components/Reveal";

const Stars = () => (
    <div className="flex gap-1">
        {[...Array(5)].map((_, i) => (
            <Star key={i} size={16} className="fill-rosegold text-rosegold" />
        ))}
    </div>
);

const Reviews = () => (
    <section
        id="recensioni"
        data-testid="reviews-section"
        className="py-24 md:py-32 bg-ink text-cream"
    >
        <div className="max-w-[1440px] mx-auto px-5 md:px-10">
            <div className="grid lg:grid-cols-[1fr_1.6fr] gap-14 lg:gap-24">
                <div>
                    <div className="lg:sticky lg:top-28">
                        <Reveal>
                            <Overline className="text-sage">Recensioni Clienti</Overline>
                            <div className="mt-6 flex items-end gap-4">
                                <span
                                    data-testid="reviews-rating-value"
                                    className="font-serif leading-none text-7xl md:text-8xl text-cream"
                                >
                                    {SALON.rating}
                                </span>
                                <div className="pb-2">
                                    <Stars />
                                    <p className="mt-2 text-sm text-cream/60">
                                        {SALON.reviewCount} recensioni verificate su Google
                                    </p>
                                </div>
                            </div>
                            <p className="mt-6 text-cream/70 leading-relaxed max-w-sm">
                                Clienti che tornano da anni, che ci consigliano ad amiche e
                                famiglie, che ci scrivono parole così. Non potremmo chiedere
                                di più.
                            </p>
                            <a
                                href={SALON.googleReviewsUrl}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="google-reviews-link"
                                className="group mt-8 inline-flex items-center gap-2 text-sm tracking-[0.12em] uppercase text-cream border-b border-cream/50 pb-1 hover:text-[#E4B7BE] hover:border-[#E4B7BE] transition-colors duration-300"
                            >
                                Leggi tutte le recensioni su Google
                                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                            </a>
                        </Reveal>
                    </div>
                </div>

                <div className="flex flex-col gap-6">
                    {REVIEWS.map((r, i) => (
                        <Reveal key={i} delay={i * 0.12}>
                            <figure
                                data-testid={`review-card-${i + 1}`}
                                className="border border-cream/10 bg-cream/[0.04] p-7 md:p-9 hover:bg-cream/[0.07] transition-colors duration-300"
                            >
                                <Stars />
                                <blockquote className="mt-5 font-serif text-lg md:text-2xl leading-relaxed text-cream/90">
                                    “{r.text}”
                                </blockquote>
                                <figcaption className="mt-5 text-xs tracking-[0.2em] uppercase text-cream/50">
                                    Recensione verificata su Google
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default Reviews;
